import { render, staticRenderFns } from "./png.vue?vue&type=template&id=c8522a02&scoped=true&"
import script from "./png.vue?vue&type=script&lang=js&"
export * from "./png.vue?vue&type=script&lang=js&"
import style0 from "./png.vue?vue&type=style&index=0&id=c8522a02&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8522a02",
  null
  
)

export default component.exports